<template>
    <Hero title="Thank you for reaching out!" colour-index="0" :buttons="[
        {
            link: 'https://app.unified.to', title: 'Sign up',
            icon: 'ic:round-keyboard-arrow-right',
        },
        {
            link: 'https://docs.unified.to',
            title: 'API Documentation',
            icon: 'ic:round-keyboard-arrow-right',
        },
        {
            link: 'https://unified.to/blog',
            title: 'Blog',
            icon: 'ic:round-keyboard-arrow-right',
        },
    ]" subtitle="Your message has been received. We'll get back to you as soon as possible.">

    </Hero>
</template>

<script lang="ts">
import { setTitle } from '~~/services/common';

export default {
    // Forms redirect here, so it must stay live (200) but out of search results (TICKET-10387).
    setup() {
        setTitle('Thank you', "Your message has been received. We'll get back to you as soon as possible.");
        useHead({ meta: [{ name: 'robots', content: 'noindex' }] });
    },
    mounted() {
        (window as any).rdt?.('track', 'contactFormSubmitted');
    },
};
</script>